import { Injectable } from '@angular/core';
import { ApiRequestService } from 'netsocial-lib/src/app/services/api-request/api-request.service';
import { LeaderboardEntry } from '../../interfaces/leaderboard-entry';
import { PaginatedItems } from 'netsocial-lib/src/app/interfaces/paginated-items';
import { Client } from 'netsocial-lib/src/app/interfaces/client';
import { isEmpty } from 'netsocial-lib/src/app/utils/object.utils';
import { Team } from 'netsocial-lib/src/app/interfaces/team';
import { User } from 'netsocial-lib/src/app/interfaces/user';

export interface GetLeaderboardParams {
  clientId?: Client['id'];
  period?: 7 | 30 | 60 | 90;
  first?: number;
  perPage?: number;
  numberOfBadges?: number;
  startDate?: string;
  endDate?: string;
  teamIds?: Array<Team['id']>;
  teamMemberIds?: Array<User['id']>;
  teamMemberName?: string;
}

@Injectable({
  providedIn: 'root',
})
export class LeaderboardService {
  constructor(private apiRequest: ApiRequestService) {}

  async getLeaderboard(body: GetLeaderboardParams = {}) {
    const response = await this.apiRequest.request('leaderboard/get', { body });

    const leaderboardItems: LeaderboardEntry[] = response.results.data.leaderboard.map(
      (item: LeaderboardEntry) => {
        const leaderboardItem = new LeaderboardEntry(item);
        return leaderboardItem;
      }
    );

    const {
      greatestEarnedValue,
      mostDeliveredPosts,
      overallTopPerformer,
      mostClicks,
      mostImpressions,
      mostLikes,
      mostShares,
    } = response.results.data.topPerformers ?? {};

    return {
      page: new PaginatedItems(leaderboardItems, response.results.data.paging, body),
      topPerformers: {
        greatestEarnedValue: !isEmpty(greatestEarnedValue)
          ? new LeaderboardEntry(greatestEarnedValue)
          : undefined,
        mostClicks: !isEmpty(mostClicks) ? new LeaderboardEntry(mostClicks) : undefined,
        mostDeliveredPosts: !isEmpty(mostDeliveredPosts)
          ? new LeaderboardEntry(mostDeliveredPosts)
          : undefined,
        mostImpressions: !isEmpty(mostImpressions)
          ? new LeaderboardEntry(mostImpressions)
          : undefined,
        mostLikes: !isEmpty(mostLikes) ? new LeaderboardEntry(mostLikes) : undefined,
        mostShares: !isEmpty(mostShares) ? new LeaderboardEntry(mostShares) : undefined,
        overallTopPerformer: !isEmpty(overallTopPerformer)
          ? new LeaderboardEntry(overallTopPerformer)
          : undefined,
      },
    };
  }
}
